/* Jestik storefront behaviour (menu, search, saved items, gallery, tabs). */
(function () {
  var SAVED_KEY = 'jestik:saved-items';

  function readSaved() {
    try {
      var list = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (w) { return w && w.handle; }) : [];
    } catch (e) { return []; }
  }
  function writeSaved(list) {
    try { localStorage.setItem(SAVED_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function isSaved(handle) {
    return readSaved().some(function (w) { return w.handle === handle; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var arrow = '<svg class="cc-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';

  /* ---------- Saved items ---------- */
  function syncSaveButtons() {
    var saved = readSaved();
    var handles = saved.map(function (w) { return w.handle; });
    document.querySelectorAll('[data-cc-save]').forEach(function (btn) {
      var on = handles.indexOf(btn.dataset.handle) !== -1;
      btn.dataset.active = on ? 'true' : 'false';
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var name = btn.dataset.title || 'item';
      btn.setAttribute('aria-label', (on ? 'Unsave ' : 'Save ') + name);
      btn.title = on ? 'Unsave item' : 'Save item';
    });
    document.querySelectorAll('[data-cc-saved-count]').forEach(function (el) {
      el.textContent = saved.length ? saved.length : '';
      el.dataset.count = saved.length;
    });
    document.querySelectorAll('[data-cc-saved-icon]').forEach(function (el) {
      el.dataset.active = saved.length ? 'true' : 'false';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cc-save]');
    if (!btn) return;
    e.preventDefault();
    var list = readSaved();
    var i = list.findIndex(function (w) { return w.handle === btn.dataset.handle; });
    if (i === -1) {
      list.unshift({
        handle: btn.dataset.handle, title: btn.dataset.title, brand: btn.dataset.brand,
        price: btn.dataset.price, url: btn.dataset.url, image: btn.dataset.image
      });
    } else {
      list.splice(i, 1);
    }
    writeSaved(list);
    syncSaveButtons();
    renderSaved();
  });

  function renderSaved() {
    var box = document.querySelector('[data-cc-saved-results]');
    if (!box) return;
    var list = readSaved();
    if (!list.length) {
      box.innerHTML = '<p class="cc-search-empty">Nothing saved yet. Tap the heart on any product to keep it here.</p>';
      return;
    }
    box.innerHTML = list.map(function (w) {
      return '<div class="cc-search-result">' +
        (w.image ? '<img src="' + esc(w.image) + '" alt="" width="58" height="70" loading="lazy">' : '') +
        '<a class="cc-search-result-text" href="' + esc(w.url) + '"><p class="cc-muted">' + esc(w.brand) + '</p><p>' + esc(w.title) + '</p></a>' +
        '<span style="font-size:12px">' + esc(w.price) + '</span>' +
        '<button type="button" class="cc-save" data-active="true" data-cc-save data-handle="' + esc(w.handle) + '" data-title="' + esc(w.title) + '" aria-label="Unsave ' + esc(w.title) + '">' +
        '<svg class="cc-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg></button>' +
        '</div>';
    }).join('');
  }

  /* ---------- Dialogs (search + saved) ---------- */
  var lastFocus = null;
  function openDialog(id) {
    var dlg = document.getElementById(id);
    var ov = document.querySelector('[data-cc-overlay]');
    if (!dlg) return;
    closeMenus();
    lastFocus = document.activeElement;
    dlg.hidden = false;
    if (ov) ov.hidden = false;
    if (id === 'cc-saved-dialog') renderSaved();
    var input = dlg.querySelector('input:not([type="hidden"])');
    (input || dlg.querySelector('button')).focus();
  }
  function closeDialogs() {
    document.querySelectorAll('.cc-dialog').forEach(function (d) { d.hidden = true; });
    var ov = document.querySelector('[data-cc-overlay]');
    if (ov) ov.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cc-open]');
    if (opener) {
      e.preventDefault();
      var topic = document.querySelector('#cc-ask-topic');
      var title = document.querySelector('[data-cc-ask-title]');
      if (opener.dataset.ccOpen === 'cc-ask-dialog') {
        if (topic) topic.value = opener.dataset.topic || 'Availability and price';
        if (title) title.textContent = opener.dataset.topic === 'A price quote' ? 'Get a quote' : 'Ask about this product';
      }
      openDialog(opener.dataset.ccOpen);
      return;
    }
    if (e.target.closest('[data-cc-close]') || e.target.matches('[data-cc-overlay]')) closeDialogs();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDialogs(); closeMenus(); }
  });

  /* Predictive search against the real catalogue */
  var searchTimer = null;
  var searchSeq = 0;
  function runSearch(input) {
    var q = input.value.trim();
    var box = document.querySelector('[data-cc-search-results]');
    var all = document.querySelector('[data-cc-search-all]');
    if (all) all.href = '/search?type=product&q=' + encodeURIComponent(q);
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; return; }
    var seq = ++searchSeq;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (seq !== searchSeq) return;
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          box.innerHTML = '<p class="cc-search-empty">No matches. Try a brand or SKU, or ask us for a quote.</p>';
          return;
        }
        box.innerHTML = items.map(function (p) {
          var quoteTags = (window.ccQuoteTags || []);
          var tagged = (p.tags || []).some(function (t) { return quoteTags.indexOf(String(t).toLowerCase().trim()) !== -1; });
          var over = window.ccQuoteAbove > 0 && Number(p.price) > window.ccQuoteAbove;
          var price = Number(p.price) > 0 && !tagged && !over ? '$' + Number(p.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 'Get a quote';
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=140';
          return '<a class="cc-search-result" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="58" height="70" loading="lazy">' : '') +
            '<div class="cc-search-result-text"><p>' + esc(p.title) + '</p></div>' +
            '<span style="font-size:12px;white-space:nowrap">' + esc(price) + '</span>' + arrow + '</a>';
        }).join('');
      })
      .catch(function () {});
  }
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cc-search-input]')) return;
    clearTimeout(searchTimer);
    var input = e.target;
    searchTimer = setTimeout(function () { runSearch(input); }, 180);
  });

  /* ---------- Browse menu ---------- */
  function closeMenus(except) {
    document.querySelectorAll('[data-cc-menu-toggle]').forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-cc-menu]').forEach(function (m) {
      if (except && m.id === except.getAttribute('aria-controls')) return;
      m.hidden = true;
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cc-menu-toggle]');
    if (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      var open = t.getAttribute('aria-expanded') !== 'true';
      closeMenus();
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.dataset.align = t.dataset.align || 'start';
        panel.hidden = !open;
        if (open && t.dataset.align !== 'end') {
          var card = panel.querySelector('.cc-menu-card');
          var wrap = panel.getBoundingClientRect();
          var r = t.getBoundingClientRect();
          if (card) {
            var inner = card.parentElement.getBoundingClientRect();
            var room = inner.width - card.offsetWidth;
            card.style.marginLeft = Math.max(0, Math.min(r.left - inner.left - 8, room)) + 'px';
          }
        } else if (panel.querySelector('.cc-menu-card')) {
          panel.querySelector('.cc-menu-card').style.marginLeft = '';
        }
      }
      return;
    }
    if (!e.target.closest('.cc-menu-card')) closeMenus();
  });

  /* ---------- Collection filters: one popover open at a time ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-cc-filter][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('toggle', function (e) {
    if (!e.target.matches || !e.target.matches('[data-cc-filter]') || !e.target.open) return;
    document.querySelectorAll('[data-cc-filter][open]').forEach(function (d) { if (d !== e.target) d.removeAttribute('open'); });
  }, true);
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-cc-filters]')) return;
    // Drop empty price inputs; send dollars as Shopify expects (price filters take whole currency units)
    e.target.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });

  /* ---------- Header "Chat" link opens Gorgias; floating bubble hidden ---------- */
  if (document.querySelector('[data-cc-chat]')) document.documentElement.classList.add('cc-chat-inline');
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cc-chat]')) return;
    e.preventDefault();
    var g = window.GorgiasChat;
    if (g && typeof g.open === 'function') { g.open(); return; }
    if (g && typeof g.init === 'function') { g.init().then(function () { window.GorgiasChat.open(); }); return; }
    window.location.href = '/pages/contact-jestik';
  });

  /* ---------- Collection sidebar: brand search + mobile drawer ---------- */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cc-brand-search]')) return;
    var q = e.target.value.trim().toLowerCase();
    var box = e.target.closest('.cc-side-group').querySelector('[data-cc-brand-chips]');
    box.querySelectorAll('a').forEach(function (a) { a.hidden = q && a.textContent.toLowerCase().indexOf(q) === -1; });
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cc-side-toggle]');
    if (!t) return;
    var root = document.querySelector('[data-cc-coll]');
    if (root) root.classList.toggle('is-open');
  });

  /* ---------- Home tabs (brand filter) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cc-tab]');
    if (!tab) return;
    var root = tab.closest('[data-cc-tabs]');
    root.querySelectorAll('[data-cc-tab]').forEach(function (b) {
      var on = b === tab;
      b.dataset.active = on ? 'true' : 'false';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-cc-panel]').forEach(function (p) {
      p.hidden = p.dataset.ccPanel !== tab.dataset.ccTab;
    });
    var link = root.querySelector('[data-cc-view-all]');
    if (link && tab.dataset.url) link.href = tab.dataset.url;
  });

  /* ---------- Product gallery ---------- */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-cc-thumb]');
    if (!th) return;
    var gallery = th.closest('[data-cc-gallery]');
    var main = gallery.querySelector('[data-cc-main-img]');
    main.src = th.dataset.src;
    main.srcset = th.dataset.srcset || '';
    main.alt = th.dataset.alt || main.alt;
    gallery.querySelectorAll('[data-cc-thumb]').forEach(function (b) {
      b.setAttribute('aria-current', b === th ? 'true' : 'false');
    });
  });

  /* ---------- Long descriptions ---------- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-cc-more]');
    if (!more) return;
    var target = document.getElementById(more.getAttribute('aria-controls'));
    var open = target.classList.toggle('is-clamped') === false;
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.firstChild.textContent = open ? 'Show less ' : 'Read more ';
  });
  function clampDescriptions() {
    document.querySelectorAll('[data-cc-clamp]').forEach(function (el) {
      var btn = document.querySelector('[aria-controls="' + el.id + '"]');
      if (el.scrollHeight > 420) { el.classList.add('is-clamped'); if (btn) btn.hidden = false; }
    });
  }

  /* ---------- Sort select on collection pages ---------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cc-sort]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Review carousel progress bar ---------- */
  function initCarousels() {
    document.querySelectorAll('[data-cc-carousel]').forEach(function (track) {
      var bar = track.parentElement.querySelector('[data-cc-carousel-bar]');
      if (!bar || track.dataset.ccBound) return;
      track.dataset.ccBound = '1';
      function update() {
        var ratio = track.clientWidth / track.scrollWidth;
        var max = track.scrollWidth - track.clientWidth;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.parentElement.style.display = ratio >= 0.999 ? 'none' : '';
        bar.style.width = (ratio * 100) + '%';
        bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      }
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Gentle reveal on scroll ---------- */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.cc-section-heading, .cc-card, .cc-review, .cc-journal-card, .cc-info-card, .cc-step, .cc-feature-body, .cc-story-inner');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t, i) {
      if (t.dataset.ccReveal) return;
      t.dataset.ccReveal = '1';
      var r = t.getBoundingClientRect();
      if (r.top < window.innerHeight) return; // already on screen: leave as is
      t.classList.add('cc-reveal');
      t.style.transitionDelay = ((i % 4) * 70) + 'ms';
      io.observe(t);
    });
  }

  function init() {
    initReveal();
    initCarousels();
    syncSaveButtons();
    clampDescriptions();
    // Reopen the question popup after the form posts back (success or error)
    if (document.querySelector('[data-cc-ask-autoopen]')) openDialog('cc-ask-dialog');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
